/**
 * One centred line of shell text on an otherwise black frame — what the
 * offline-reset shortcut (`offline/unstale.ts`) puts on screen so the user can
 * see it fired.
 *
 * Deliberately the start gate's own vocabulary rather than DOM chrome: the
 * same `FONT1`, the same centre line, the same flat tan the gate's `LOADING`
 * uses. The shortcut exists for the case where the shell is already broken, so
 * its feedback has to come from the smallest possible amount of machinery —
 * one `fill` and one `text` op, no menu model, no assets beyond the font
 * atlas that is already loaded.
 *
 * Pure, like every other `*-chrome`/screen module here: a `DrawOp` list
 * against palette indices, assertable without a canvas.
 */

import { type DrawOp, fill, type FontId, LOGICAL_HEIGHT, LOGICAL_WIDTH, type TextStyle } from "./draw-ops.ts";
import { TAN_233 } from "./ps-palette.ts";
import { centerTextX, type FontAtlas } from "./text-metrics.ts";

export const NOTICE_FONT: FontId = "FONT1";
/** The gate's own text row — a 12-row glyph plus its emboss, dead centre. */
export const NOTICE_TEXT_Y = 93;
const NOTICE_STYLE: TextStyle = { body: TAN_233 };

export function noticeScreenOps(text: string, font: FontAtlas): DrawOp[] {
  return [
    fill({ x: 0, y: 0, w: LOGICAL_WIDTH, h: LOGICAL_HEIGHT }, 0),
    {
      kind: "text",
      font: NOTICE_FONT,
      text,
      x: centerTextX(font, text, LOGICAL_WIDTH / 2),
      y: NOTICE_TEXT_Y,
      style: NOTICE_STYLE,
    },
  ];
}
